import { useEffect, useState } from "react";
import { beiSprachwechsel, sprache } from "./index.js";

/* Sorgt dafür, dass Komponenten nach einem Sprachwechsel neu zeichnen.
   Die Übersetzung selbst läuft über t(); dieser Haken liefert nur den
   Anstoß zum Neuzeichnen. */
function useSprache() {
  const [, setStand] = useState(sprache());
  useEffect(() => beiSprachwechsel(setStand), []);
  return sprache();
}

/* Kleiner Umschalter — im geteilten Bereich sichtbar für Gäste. */
function Sprachwahl({ wert, onWechsel, sprachen, className = "" }) {
  return (
    <select className={"wl-sprachwahl " + className} value={wert}
      onChange={(e) => onWechsel(e.target.value)} aria-label="Sprache">
      {sprachen.map((s) => <option key={s.code} value={s.code}>{s.name}</option>)}
    </select>
  );
}

export { Sprachwahl, useSprache };
